interface IconTransitionTopFilledProps {
  size?: number | string;
  color?: string;
  className?: string;
}
/**
 *
 * IconTransitionTopFilled
 */
const IconTransitionTopFilled = ({ size = 48, color = '#4ADDC2', className }: IconTransitionTopFilledProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_93_9691)">
      <path
        d="M24.5 12L24.662 12.006L24.902 12.04L25.124 12.1L25.346 12.188L25.542 12.292L25.75 12.44L25.914 12.586L31.914 18.586C32.105 18.7705 32.2574 18.9912 32.3622 19.2352C32.467 19.4792 32.5222 19.7416 32.5245 20.0072C32.5268 20.2728 32.4762 20.5361 32.3756 20.7819C32.2751 21.0277 32.1266 21.251 31.9388 21.4388C31.751 21.6266 31.5277 21.7751 31.2819 21.8756C31.0361 21.9762 30.7728 22.0268 30.5072 22.0245C30.2416 22.0222 29.9792 21.967 29.7352 21.8622C29.4912 21.7574 29.2705 21.605 29.086 21.414L26.5 18.83V28H36.5C38.6217 28 40.6566 28.8429 42.1569 30.3431C43.6571 31.8434 44.5 33.8783 44.5 36C44.5 38.1217 43.6571 40.1566 42.1569 41.6569C40.6566 43.1571 38.6217 44 36.5 44H12.5C10.3783 44 8.34344 43.1571 6.84315 41.6569C5.34285 40.1566 4.5 38.1217 4.5 36C4.5 33.8783 5.34285 31.8434 6.84315 30.3431C8.34344 28.8429 10.3783 28 12.5 28H22.5V18.83L19.914 21.414C19.5696 21.7584 19.1114 21.9652 18.6254 21.9958C18.1393 22.0263 17.6588 21.8785 17.274 21.58L17.086 21.414C16.7111 21.0389 16.5004 20.5303 16.5004 20C16.5004 19.4697 16.7111 18.9611 17.086 18.586L23.086 12.586L23.31 12.392L23.53 12.25L23.654 12.188L23.816 12.12L23.968 12.072L24.204 12.022L24.32 12.008L24.5 12ZM36.5 4C38.6217 4 40.6566 4.84285 42.1569 6.34315C43.6571 7.84344 44.5 9.87827 44.5 12C44.4994 12.5098 44.3042 13.0001 43.9543 13.3707C43.6044 13.7414 43.1261 13.9645 42.6172 13.9943C42.1083 14.0242 41.6072 13.8587 41.2163 13.5315C40.8254 13.2043 40.5742 12.7402 40.514 12.234L40.5 12C40.5 10.9391 40.0786 9.92172 39.3284 9.17157C38.5783 8.42143 37.5609 8 36.5 8H12.5C11.4391 8 10.4217 8.42143 9.67157 9.17157C8.92143 9.92172 8.5 10.9391 8.5 12C8.5 12.5304 8.28929 13.0391 7.91421 13.4142C7.53914 13.7893 7.03043 14 6.5 14C5.96957 14 5.46086 13.7893 5.08579 13.4142C4.71071 13.0391 4.5 12.5304 4.5 12C4.5 9.87827 5.34285 7.84344 6.84315 6.34315C8.34344 4.84285 10.3783 4 12.5 4H36.5Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_93_9691">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconTransitionTopFilled;
